import React from 'react';
import { EditIconBlue } from 'assets/icons';
import { getAmountWithCurrency } from 'utils/amountUtils';
import { VoidFn } from 'types/baseTypes';
import If from 'components/If/If';

interface PartialAmountHeaderProps {
  pendingAmount: number;
  customAmount?: number;
  handleEditAmountClick?: VoidFn;
  isPartialPaymentEnabled?: boolean;
}

export const PartialAmountHeader: React.FC<PartialAmountHeaderProps> = ({
  pendingAmount,
  customAmount,
  handleEditAmountClick,
  isPartialPaymentEnabled
}) => {
  const remainingAmount = getAmountWithCurrency(pendingAmount);
  const amountPayable = customAmount ? getAmountWithCurrency(customAmount) : remainingAmount;
  return (
    <div className="flex w-full flex-col items-center gap-2 border-b border-borderGray pb-5">
      <div className="text-sbase font-bold text-primaryText">Payment amount</div>
      <div className="pt-1 text-4xl font-bold text-headingBlack">{amountPayable}</div>
      <If condition={isPartialPaymentEnabled}>
        <button
          id="edit-amount-button"
          onClick={handleEditAmountClick}
          className="flex cursor-pointer items-center gap-1 text-sbase font-semibold text-secondary ">
          <span>
            <EditIconBlue className="h-4 w-4 shrink-0" />
          </span>
          Edit amount
        </button>
      </If>
      <If condition={amountPayable !== remainingAmount}>
        <div className="pt-1 text-[15px] text-primaryText">of {remainingAmount} remaining amount</div>
      </If>
    </div>
  );
};
